import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';
import { Observable } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import {
  BaseComponent,
  FormService,
  GridComponent,
  GridService,
  NotificationService,
  TranslationService,
} from '../../../../tms-shared';
import { UserChart } from '../../models';
import { UserService } from '../../services';

@Component({
  selector: 'app-user-charts',
  templateUrl: './user-charts.component.html',
  styleUrl: './user-charts.component.scss',
})
export class UserChartsComponent extends BaseComponent implements OnInit {
  @ViewChild(GridComponent) grid: GridComponent;

  columnDefs: ColDef[] = [
    ...this.gridService.checkboxRowSelect('name', $localize`Name`, undefined, undefined, { rowDrag: true }),
  ];

  rowData$: Observable<UserChart[]>;

  private userId: string;

  constructor(
    private userService: UserService,
    private gridService: GridService,
    private formService: FormService,
    private notificationService: NotificationService,
    private translationService: TranslationService,
    private route: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit(): void {
    this.userId = this.route.snapshot.paramMap.get('id');
    this.getModel();
  }

  private getModel() {
    this.rowData$ = this.userService.getUserCharts(this.userId).pipe(
      takeUntil(this.destroy$),
      map((userCharts: UserChart[]) =>
        userCharts.map((userChart: UserChart) => ({
          ...userChart,
          name: this.translationService.translateChart(userChart.name),
        })),
      ),
    );
    this.grid?.resetEdited();
  }

  save() {
    if (this.grid.edited) {
      this.formService.beginSave();
      this.userService
        .updateUserCharts(this.userId, this.grid.selectedIds)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: () => {
            this.notificationService.saveSuccess($localize`User Charts`);
            this.getModel();
            this.formService.endSave(false);
          },
          error: () => {
            this.notificationService.saveFail($localize`User Charts`);
            this.formService.endSave(true);
          },
        });
    }
  }
}
